import { render, staticRenderFns } from "./correlationTest.vue?vue&type=template&id=a98e2e74&scoped=true&"
import script from "./correlationTest.vue?vue&type=script&lang=js&"
export * from "./correlationTest.vue?vue&type=script&lang=js&"
import style0 from "./correlationTest.vue?vue&type=style&index=0&id=a98e2e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e2e74",
  null
  
)

export default component.exports